import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { ContentUpgrades } from "@swizec/gatsby-theme-course-platform";
export const _frontmatter = {
  "title": "Different medium, different mindset",
  "description": "Ever wondered what it's like to make a physical book? It ain't as easy as shipping code lemme tell ya 😅",
  "published": "2021-03-19T00:00:00.000Z",
  "hero": "./img/screenshot-1616172096221.png",
  "categories": "Books, Lessons, Serverless",
  "content_upgrade": "ServerlessHandbook"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Ever wondered what it's like to make a physical book? It ain't as easy as shipping code lemme tell ya 😅`}</p>
    <p>{`It's been 8 years since I published a physical book. Back then a publisher reached out and said `}<em parentName="p">{`"Hey wanna write a book based on this cool blogpost of yours?"`}</em></p>
    <p>{`Heck yeah I do!`}</p>
    <p>{`By the time it was done, I was so sick of the process that I never picked up my copies from the post office. Even gave a talk vowing never to do that again.`}</p>
    <lite-youtube {...{
      "videoid": "w1L2SgQuv6Q",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Writing books is like running marathons.`}</p>
    <p>{`You finish the race, say this was stupid I'll never do it again, and sign up for the next race 3 weeks later.`}</p>
    <ContentUpgrades.ServerlessHandbook />
    <h2 {...{
      "id": "digital-for-the-win"
    }}>{`Digital for the win`}</h2>
    <p>{`Since that first book, I've been publishing digital books and courses.`}</p>
    <p>{`Digital books are easy. You write in markdown using a text editor. I like iA Writer because it's pretty and clean.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/e2a54648c0252b62a717248efb87994e/f7171/Writing-in-iA-Writer12d0gg.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "67.71300448430493%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'271\\'%20viewBox=\\'0%200%20400%20271\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2014v14h2c2%200%203%200%202%202l-2%201c-2%200-2%203-2%20120v120h24c21%200%2025-1%2024-2h3c3%202%2011%202%2029%201h9c1-1%202-2%203-1h7c3-2%204-2%208-1l5%201c1-1%205%200%205%201h7l140%201h137V0H0v14m262-6c-32%200-32%200-31%202l-1%202-2-1-1-3-1%202c1%201%201%201%200%200h-2l-1-2v2h-4V8l-1%201-1%201-1%201c-1%201-1%201-1-1%200-1%200-2-1-1l-1%202v1l-1-2-2-2v2l-1%202c-2%200-2-1-1-2l-1-2-2%202c0%202-2%203-2%200l-1-2v2l-1%202-2-2-1-2v2h-5c0-1-1-2-3-2s-3%200-2%202c0%202-2%204-3%203l1-2v-1h-1V9l-1-1-1%202h-2c-1%201-1%201%200%200l-2-2-1%202c1%203-1%203-1%200l-1-2-1%202-1%201V9l-1%202c-1%201-1%201-1-1l-1-2v2c0%202%200%202-1%201l-1-2v2c-1%201-1%201-1-1l-2-2c-3%200-5%202-4%203l-1%201-1-2c0-2-1-2-3-2s-3%200-2%201l-1%201v1l-1%201-1-2-1-2-1%202-1%202-2-2-1-2-1%202v2l-2-2-1-2-1%202v2c-1%200-2-1-1-2%200-2%200-2-3-2l-5%201h-12l-1%201V9l-1-1-1%202-1%202-2-2-1-2v2l-1%202c-2%200-2-1-2-2V8c-1%200-2%201-1%202l-1%202-2-2-1-2v2h-2v2l-1-2c0-2-1-2-3-2s-3%200-2%202c0%202-2%204-3%202l1-1v-1h-2V8l-1%202h-2V9l-2-1-1%202v2l-1-2-1-2-1%202c0%203-2%202-2%200l-2-2-1%202c1%201%200%202-1%202v-1l-1-2c-1-1-1%200-2%201%200%202-2%203-2%201%201-3%200-3-1-1l-2%201h-1c-2%201-2%201-2-1V8H40L13%209l-1%20124c0%20124%200%20125%202%20126s372%200%20374-1V9c-1-1-61-2-126-1M0%20151\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e2a54648c0252b62a717248efb87994e/ca0a1/Writing-in-iA-Writer12d0gg.webp 223w", "/static/e2a54648c0252b62a717248efb87994e/75680/Writing-in-iA-Writer12d0gg.webp 445w", "/static/e2a54648c0252b62a717248efb87994e/8d1ba/Writing-in-iA-Writer12d0gg.webp 890w", "/static/e2a54648c0252b62a717248efb87994e/3838e/Writing-in-iA-Writer12d0gg.webp 1335w", "/static/e2a54648c0252b62a717248efb87994e/e11e5/Writing-in-iA-Writer12d0gg.webp 1780w", "/static/e2a54648c0252b62a717248efb87994e/5c339/Writing-in-iA-Writer12d0gg.webp 3456w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e2a54648c0252b62a717248efb87994e/e92b6/Writing-in-iA-Writer12d0gg.png 223w", "/static/e2a54648c0252b62a717248efb87994e/e66bf/Writing-in-iA-Writer12d0gg.png 445w", "/static/e2a54648c0252b62a717248efb87994e/4ef49/Writing-in-iA-Writer12d0gg.png 890w", "/static/e2a54648c0252b62a717248efb87994e/4e814/Writing-in-iA-Writer12d0gg.png 1335w", "/static/e2a54648c0252b62a717248efb87994e/701e9/Writing-in-iA-Writer12d0gg.png 1780w", "/static/e2a54648c0252b62a717248efb87994e/f7171/Writing-in-iA-Writer12d0gg.png 3456w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e2a54648c0252b62a717248efb87994e/4ef49/Writing-in-iA-Writer12d0gg.png",
                "alt": "Writing in iA Writer",
                "title": "Writing in iA Writer",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Writing in iA Writer`}</figcaption>{`
  `}</figure></p>
    <p>{`Put that on GitHub and you get version control `}<em parentName="p">{`and`}</em>{` render previews on the web. Wonderful.`}</p>
    <p>{`Add a pdf/epub generator like `}<a parentName="p" {...{
        "href": "https://leanpub.com/"
      }}>{`Leanpub`}</a>{` or `}<a parentName="p" {...{
        "href": "https://www.remarq.io/"
      }}>{`Remarq`}</a>{` and you can offer "books". Ebooks were big as email signup freebies for a few years.`}</p>
    <p>{`Desktop is where my e-books go to die. Never read a single freebie e-book that I downloaded. 😂`}</p>
    <p>{`That's why I always added a price to my ebooks. Figured people would value them more. And if you value it more, you read it. And if you read it, it becomes valuable.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media1.giphy.com/media/3ohjUSV3H14VzJIZfq/giphy-loop.mp4?cid=7cf28b0fya82rbfjk39a3mffv4bbjtyxuipi1kj1lnnpn8ev&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <h2 {...{
      "id": "digital-is-agile-️"
    }}>{`Digital is Agile ❤️`}</h2>
    <p>{`Agile is a bad word among cynical engineers, but it's way better than waterfall.`}</p>
    <p>{`Waterfall being the approach where you plan a big project in every detail, get to work, discover your plan is all wrong, and keep trying to hit the deadline. Then you wonder why everyone's tired and burned out.`}</p>
    <p>{`Agile means you tinker. Garden your way to perfection.`}</p>
    <p>{`Little trim here, supporting touch there, sprinkle a dash of love, hit submit. Then do it again tomorrow.`}</p>
    <p>{`You iterate.`}</p>
    <p>{`That's why Serverless Handbook started as an interactive website, not even a pdf. Oh there's a typo? A bug? Weird wording?`}</p>
    <ol>
      <li parentName="ol">{`tweak`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`git commit`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`git push master`}</inlineCode></li>
    </ol>
    <p>{`Changes live in production in 2 minutes 😍`}</p>
    <p>{`Look at how many "editions" it's had!`}</p>
    <p><img parentName="p" {...{
        "src": "/f7f81ab7c25e074d9fa3b9d7eac5a96b/Every-digital-edition-of-Serverless-Handbook6b6cfh.gif",
        "alt": "Every digital \"edition\" of Serverless Handbook"
      }}></img></p>
    <p>{`528 days since first going up 🤯`}</p>
    <h2 {...{
      "id": "paper-means-waterfall"
    }}>{`Paper means waterfall`}</h2>
    <p>{`And then I had a bright idea. What if Serverless Handbook became a `}<em parentName="p">{`real`}</em>{` book? How hard can it be!`}</p>
    <p>{`By mid January, the book was finished. All chapters done. Huzzah! 💪`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.lulu.com/"
      }}>{`Lulu`}</a>{` can do print on demand, Gumroad can do sales, hook them together and that should work. Tell early supporters book is coming out by mid February.`}</p>
    <p>{`Wait shit, you can't edit a physical book!`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media3.giphy.com/media/2wh22BgaFoU2QFwyFl/giphy-loop.mp4?cid=7cf28b0ffd8nroipp6lo7tx93u5ue5nz2tr5l92997pojn7r&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`Editing to the rescue!`}</p>
    <p>{`Went through the whole book and fixed a bunch. Whole paragraphs got cut, an entire chapter, and I reshuffled topics for better flow.`}</p>
    <p>{`While doing that, I asked `}<a parentName="p" {...{
        "href": "https://twitter.com/stas_kulesh"
      }}>{`Stas`}</a>{`, who designed the original chapter art, for a cover. He said yes!`}</p>
    <p>{`A few days later we had a cover. And I kept editing.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/fe883544ba6a192faec1f1e32f7646a0/914c7/Early-cover-drafti723i1.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "113.00448430493275%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'452\\'%20viewBox=\\'0%200%20400%20452\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M232%2060c-4%203-6%207-6%2011s2%205%207%205c4-1%204-1%204%201%200%203-4%205-5%203s-6%200-6%202c0%2010%2015%203%2017-7%200-6-1-7-7-6-4%200-4%200-4-2%201-2%204-4%205-2s5-1%205-3c0-4-6-5-10-2m-18%209c-10%206-9%2018%201%2016%204%200%205%200%203%203-1%202-2%202-4%202-6-2-9%202-5%205%206%206%2019-8%2015-15-1-2-2-2-6-2h-5c0-3%203-5%204-4h6v-4c-2-4-4-4-9-1m-34%208l-2%201%201%2018v18l3-1c3-1%203-2%203-7l-2-30-3%201m14%202c-7%204-10%2020-5%2026%203%203%206%202%2011-1%203-3%207-11%206-12-1%200-6%202-6%204l-5%204c-4-2-2-5%205-8%206-3%206-3%206-7-2-8-6-10-12-6m-20%2011l-5%202-3%202v27l3-1c3-2%203-2%203-12%200-9%200-9%202-12%202-1%203-3%203-5%200-3-1-4-3-1m-22%2011c-7%205-9%2020-5%2026s16-2%2016-11c0-3-4-1-6%203-2%203-6%204-6%201-1-2%200-3%206-6l7-3-1-4c-1-8-6-10-11-6m69%203c-2%201-2%203-1%2019l1%2017c3%200%205-3%205-8%200-6%200-6%204-2%203%203%203%203%206%202l3-2-3-4-4-6c-1%200%200-4%202-7l3-8c-2-1-6%204-9%209l-2%206-1-9c0-8-1-9-4-7m-80%203c-3%201-5%2010-5%2019%200%204-2%201-3-6l-2-7c-1-1-9%202-11%205l-1%201-3%201-3%201v14l1%2014%203-2c3-1%203-1%203-11s0-10%202-13l3-4c0-1%202%202%203%208l4%2012%207-4%203-14c2-16%202-16-1-14m90%2049l-87%2051-1%2018%201%2017%201-4c2-2%203-3%205-3h3v-24l80-46%2083-48c2-1%203-1%206%201%204%203%204%203%204-3%200-5%200-5-3-7l-5-2-87%2050m-27-33c-10%2010-7%2029%203%2025%209-4%2014-18%208-27-2-3-6-3-11%202m-101%203c-8%203-13%2019-9%2027%203%207%2013%203%2016-7%203-6%200-6-6%202-2%203-5%202-5-1%200-1%202-3%206-5l7-4c1-3-2-10-4-11-3-2-3-2-5-1m-22%202c-9%204-14%2016-9%2022%201%202%202%202%207%202l6-1v3c0%205-8%2010-9%206-1-2-6%201-6%203%200%207%207%208%2014%202%205-4%207-8%207-14%200-7-2-8-8-8h-7c-1-2%201-6%204-8h4c1%203%206%201%206-2%200-5-5-8-9-5m104%204c-11%207-10%2032%201%2028%209-3%2014-22%208-28-3-3-5-2-9%200m-27%206c-2%201-2%203-2%2016l1%2019%201%204%203-3%204-3c6%201%2012-11%2011-21-1-9-6-11-11-6l-3%203v-5c0-5-1-6-4-4m-8%205c-3%201-3%202-3%207s0%206-2%206c-8-3-15%2019-9%2027%203%204%205%204%209%200l3-3%203-1%203-1-1-18v-19l-3%202m-25%2022l-4%204-2%201c0-1-1-1-3%201l-3%201v14l1%2014%204-2c2-1%202-1%202-10-1-9%201-15%204-15%201%200%202%202%202%2010%200%2011%200%2011%204%208%202-1%202-2%202-11%200-13-2-17-7-15m-24%2013l-4%204c-2%203-4%2010-3%2010l5-4%205-4c2%202%201%204-3%206-5%204-8%208-8%2013%200%207%204%209%209%204l3-2%203-1c3-2%203-2%203-12%200-15-2-18-10-14m-27%206c-2%201-3%2019-1%2033v7l3-2%203-1-1-9c0-11%201-16%205-16%201%200%202%202%202%2010%200%2010%201%2011%204%209%202-2%203-20%201-24-2-5-6-5-10%201l-2%202v-5c0-6-1-7-4-5m177%2030l-16%209-4-2c-3-2-3-2-3%200-1%204%200%2057%201%2058%204%201%2012%206%2011%207s-3%200-7-2l-7-3%206%205c5%203%206%203%205%204s-4%200-8-2l-6-3c-1%200%202%203%207%205l5%203c0%202-4%201-9-2l-6-2%207%205c4%202%205%203%204%204l-8-3-7-3c-1%201%200%201%207%205%205%203%206%204%205%205l-8-3-7-3c0%201-1%201%206%205l5%204c0%202-1%201-8-2l-6-3%206%205%207%203%2018-9%2019-10%209%205c6%203%208%204%207%205s-3%200-9-2l-8-4-49%2025a80524%2080524%200%2001-97%2050l15%209%2016%208-8%205-7%204%2045%2022a374%20374%200%200050%2022h5c3-2%205-2%205-1h3c2-2%206-1%205%200-1%202-15%208-16%208l-48-23-45-22-9%204-8%205-17-8-17-8v3c0%209-1%2010-5%2010-7-1-15%204-15%2010%200%202-1%202-4%201-13-1-14%2017-2%2030l4%205h85l7-4c10-5%208-7-3-2l-10%205%208-6c5-2%209-5%209-6%200-2-1-1-10%204l-9%204c-2%200%200-2%208-6%205-2%208-5%208-6%200-2%200-1-10%204-8%204-9%205-9%203%200-1%203-3%207-4%208-5%2011-7%2010-8l-10%204-9%204%207-5%209-6c0-2-1-1-8%202l-11%205%208-5%209-7c0-2%200-1-10%204l-9%204c-3%200%200-2%208-6l8-6c0-1%205%201%2014%206l14%208v20h169v-30l9-4%208-4v-46l-1-47-3%202c-6%204-17%209-19%209-1%200%202-3%208-5l9-7-9%203-10%205c-3%200%200-2%208-6%205-2%208-5%208-6l-9%204-10%204c-1-1-1-1%209-6l8-6c0-2-1-1-10%203l-9%204%207-5c5-2%209-5%209-6l-9%204-10%204c-1-1%200-1%209-6%205-2%208-5%208-6%200-2%200-2-10%203-11%206-13%205-1-1l8-6c0-2%200-1-10%203l-9%204%207-5%209-5c3-3%200-2-8%202l-10%204%207-5%209-6c0-2-1-1-9%203l-9%204-29-14c-24-12-31-15-33-14-4%200-15-6-12-7%202-1%202-2%202-18%201-18%202-23%206-24%203-2%204%201%205%2016v13l4%202c4%203%2015%209%2018%209%202%201%202%201%202-7%200-9%200-9-5-6l-4%202v-22l-1-23-17%208m44%2021c-2%202-2%203-2%205%202%208%202%209%200%2012l-3%204-3-2c-5-3-5-2-5%2010%200%209%200%2011%202%2012%204%203%2017%2010%2018%209l1-10c0-9%200-11-2-12-2-2-2-2%200-4%203-3%203-7-1-9-2-1-2-2-1-5%200-5%200-5%206-1%204%202%205%204%205%205l2%204%201%207c0%206%200%206-3%207-3%202-4%204-4%2010%200%204%201%206%202%207l2%205%204%204%203%202%205-2c3-1%205-3%205-4l2-4c2-2%202-3%202-8v-7l-4-3c-4-2-5-3-6-9v-8c3-5%200-10-6-9-4%201-14-3-14-5l-2-2c-2-1-2-1-4%201m-183%2037c-3%202-2%203%201%203%206%200%209%204%2026%2027a194%20194%200%200020%2025l1%204%202%203%201-2c3-4%201-8-3-12l-18-23c-8-13-16-22-18-24-4-2-10-3-12-1m196%204c-1%204%200%205%206%209%205%203%209%202%2011-3%202-4%201-6-2-5-3%202-6%201-10-2l-5-3v4m-13%2035v17h14v-10c0-7-1-11-2-13-2-4-9-12-11-12l-1%2018m-99%2024l-59%2031%2017%209%2016%208-10%205-9%205%203%202c8%205%2072%2037%2073%2036%202-1%201-2-18-11l-19-9v-25c0-23%200-25%202-24%205%206%2020%206%2026%201l2-3c0-4-11-9-17-8-3%201-3%200-3-3l-1-3a1193%201193%200%2000-22%2011c-4-1-8%200-9%203l-8%206c-7%203-10%204-13%201-2-2%202-4%2055-31l58-29-3-2-61%2030m99%2030v12l-10%205-11%206c0%202%202%201%2014-4l13-7%202%203c4%204%204%204%2019-3%2014-7%2016-10%2016-15%200-3-1-4-3-4h-5l-5-1c-1%201-3%200-4-1-3-1-5-1-8%201-4%201-4%201-4-2%200-2-1-2-7-2h-7v12m-191%2010v6l10%205%2011%205%206-3%206-3-15-8-17-8-1%206m63%2013l-10%206%204%202%203%202%208-4c7-3%207-4%207-7%200-5%201-5-12%201m105%2030l-11%206-9-4c-7-4-12-5-12-2l10%205%2010%205%2011-5c7-4%2010-6%2011-8%203-4%202-4-10%203\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fe883544ba6a192faec1f1e32f7646a0/ca0a1/Early-cover-drafti723i1.webp 223w", "/static/fe883544ba6a192faec1f1e32f7646a0/75680/Early-cover-drafti723i1.webp 445w", "/static/fe883544ba6a192faec1f1e32f7646a0/8d1ba/Early-cover-drafti723i1.webp 890w", "/static/fe883544ba6a192faec1f1e32f7646a0/0e613/Early-cover-drafti723i1.webp 978w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fe883544ba6a192faec1f1e32f7646a0/e92b6/Early-cover-drafti723i1.png 223w", "/static/fe883544ba6a192faec1f1e32f7646a0/e66bf/Early-cover-drafti723i1.png 445w", "/static/fe883544ba6a192faec1f1e32f7646a0/4ef49/Early-cover-drafti723i1.png 890w", "/static/fe883544ba6a192faec1f1e32f7646a0/914c7/Early-cover-drafti723i1.png 978w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/fe883544ba6a192faec1f1e32f7646a0/4ef49/Early-cover-drafti723i1.png",
                "alt": "Early cover draft",
                "title": "Early cover draft",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Early cover draft`}</figcaption>{`
  `}</figure></p>
    <h3 {...{
      "id": "the-waterfall-keeps-waterfalling"
    }}>{`The waterfall keeps waterfalling`}</h3>
    <p>{`A physical book `}<em parentName="p">{`cannot`}</em>{` change after print. You have to read all 300+ pages out loud to find odd wordings.`}</p>
    <p>{`That helped.`}</p>
    <p>{`And then came the layouting. Oh god the layouting ...`}</p>
    <p>{`Everyone who sells book layouting on Fiverr laughed me out of the chatroom. Serverless Handbook is way too complex 😅`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.remarq.io/"
      }}>{`Remarq`}</a>{` to the rescue! One of the output modes is a print ready pdf. This'll be a breeze.`}</p>
    <p>{`It was not a breeze.`}</p>
    <p>{`Getting everything `}<em parentName="p">{`into`}</em>{` Remarq was easy enough. I outsourced that part 😇`}</p>
    <h2 {...{
      "id": "we-broke-the-layouting-tool"
    }}>{`We broke the layouting tool`}</h2>
    <p>{`Serverless Handbook was so complex it broke Remarq. Many times over. The founder said it was like a stress test of his technology. Fixed a bunch of bugs we uncovered 🤘`}</p>
    <p>{`I ordered the first test print. Mid February by now.`}</p>
    <p>{`It kinda looked like shit ...`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Look what arrived in the mail this week! The Serverless Handbook test print 🥳`}<br parentName="p"></br><br parentName="p"></br>{`Partnering with `}<a parentName="p" {...{
          "href": "https://twitter.com/GatekeeperPress"
        }}>{`@GatekeeperPress`}</a>{` to make it "available wherever books are sold" end of March, preorders coming to an email inbox near you soon 🤘 `}<a parentName="p" {...{
          "href": "https://t.co/ZnxnQSawsz"
        }}>{`pic.twitter.com/ZnxnQSawsz`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1367163107974541315"
      }}>{`March 3, 2021`}</a></blockquote>
    <p>{`The pages were weird, the cover looked bad, everything was terrible.`}</p>
    <p>{`Back to Remarq! Painstakingly adding page breaks, tweaking image sizes, chapter by chapter, page by page.`}</p>
    <p>{`And then Stas was like `}<em parentName="p">{`"Hey Swiz, I need exact dimensions, especially thickness, to make a nice cover"`}</em>{`. Can't know that until the layout is perfect can you 😅`}</p>
    <p>{`It took over 2 weeks to get that ready. WEEKS! To finish a finished book.`}</p>
    <p>{`But hot damn it looks great 😍`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Well well well if it isn’t the consequences of my own actions `}<a parentName="p" {...{
          "href": "https://t.co/J4qeWGCJyd"
        }}>{`pic.twitter.com/J4qeWGCJyd`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1371919072342855680"
      }}>{`March 16, 2021`}</a></blockquote>
    <p>{`And guess what?`}</p>
    <p>{`There's a typo on the cover and the inner margins are too small. Code on right pages goes into the spine and you can't read it.`}</p>
    <p>{`New test print coming next week 🤘`}</p>
    <p>{`And the publisher I hired to help with global distribution committed to a Mar 31st publication date. Stay tuned`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: moving from old skool servers to serverless is a lot like going from physical to digital books 😉`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      